import { render } from "./Present.vue?vue&type=template&id=a76d0b40"
import script from "./Present.vue?vue&type=script&lang=js"
export * from "./Present.vue?vue&type=script&lang=js"

import "./Present.vue?vue&type=style&index=0&id=a76d0b40&lang=scss"

import exportComponent from "/var/www/basic/vue-about-us/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__